var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductionLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48799 0C1.77487 0 0.000976562 1.78157 0.000976562 4.1232C0.000976562 6.41312 1.72203 8.24551 4.38388 8.24551H4.43537C7.20157 8.24551 8.92307 6.41312 8.92307 4.1232C8.87135 1.78157 7.20157 0 4.48799 0Z",
    fill: "#B0DAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.469727 11.5037H8.40133V35.3662H0.469727V11.5037Z",
    fill: "#B0DAC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8698 10.9434C23.591 10.9434 20.7219 14.964 20.7219 14.964V11.5034H12.79V35.366H20.7214V22.0402C20.7214 21.3268 20.7731 20.6145 20.9827 20.1044C21.5561 18.6798 22.8609 17.204 25.0522 17.204C27.9222 17.204 29.0701 19.3923 29.0701 22.6003V35.366H37.001V21.6836C37.001 14.3541 33.0879 10.9434 27.8698 10.9434Z",
    fill: "#B0DAC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductionLinkedin);
export default __webpack_public_path__ + "static/media/Production_linkedin.dd9b61f9.svg";
export { ForwardRef as ReactComponent };